import { Resources } from './resources'


class UsersResources extends Resources {
  getUserId ( data ) {
    return this.http.post( this.baseUrl, data )
  }
}

// const endPoint =
//   process.env.NODE_ENV === 'development'
//     ? 'http://users.localhost'
//     : 'https://auth.omb11.com'

const endPoint = process.env.REACT_APP_AUTH_URL

export default new UsersResources( 'users', endPoint )



// WEBPACK FOOTER //
// ./src/resources/users.js